// getListNotificationSaga
import { callApiServiceCommon } from "./service-common";

const dashboardApi = process.env.REACT_APP_DASHBOARD_API;
const commonServiceApi = process.env.REACT_APP_API_COMMON_SERVICE;

export function* changeStatusService(status) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/on-off-app`,
    params: {
      //   shop_domain: shopUrl,
      status_app: status,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* updateNotificationService(shop, id) {
  const payload = {
    method: "POST",
    url: `${commonServiceApi}/ak/update-notification`,
    params: {
      app_code: "rev",
      shop_domain: shop,
      notification_id: id,
      read_status: true,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getListNotificationService(shop) {
  const payload = {
    method: "GET",
    params: {
      app_code: "rev",
      shop_domain: shop,
    },
    url: `${commonServiceApi}/ak/get-notification`,
  };
  return yield callApiServiceCommon(payload);
}

export function* getNotificationDetailService(shop, id) {
  const payload = {
    method: "GET",
    params: {
      app_code: "rev",
      shop_domain: shop,
      notification_id: id,
    },
    url: `${commonServiceApi}/ak/get-notification`,
  };
  return yield callApiServiceCommon(payload);
}
